import { writable, get } from 'svelte/store';
import { goto } from '$app/navigation';
import { browser } from '$app/environment';

// Route history
export const history = writable(['/']);

export interface ParaUser {
	id: string;
	walletAddress?: string; // Optional for privacy - only included when needed
	email: string;
	member?: boolean; // Optional - can be undefined until profile loads
}

export const user = writable<ParaUser | undefined>();

// Flag to prevent auth redirects during logout
export const isLoggingOut = writable(false);

export interface ParaSession {
	logout: () => Promise<void>;
	init: () => Promise<void>;
}

// Utility function to handle auth redirects that respects the logout flag
export const redirectToAuth = () => {
	if (browser && !get(isLoggingOut)) {
		goto('/');
	}
};
